export default (axios) => ({
    getAll: (params) => axios.get('u/doctors?status=true&origin=benhvien16a.com', { params }).then((_) => _.data),
    getShowHome: (params) => axios.get('u/doctors?showHome=true&origin=benhvien16a.com', { params }).then((_) => _.data),
});
